import apiClient from 'utils/apiClient';
import { useSWRConfig } from 'swr';
import API_BASE_URL from 'config/api';

export default function useDelete(endpoint) {
  const { mutate } = useSWRConfig();

  const remove = async (id, opts = { revalidate: true }) => {
    const url = `${endpoint}/${id}`;
    const res = await apiClient.delete(url);
    if (opts.revalidate) await mutate(endpoint);
    return res.data;
  };

  return { remove };
}
